import WebsiteTemplatesPage from "@/components/Home/v2/WebsiteTemplatesPage";

export default WebsiteTemplatesPage;
